import React from 'react';
import PropTypes from 'prop-types';

import {
  formatCnpjMask,
  normalizeCnpjForStorage
} from '../../../../../../legacy/js/formatters/cnpj-dual';

/**
 * Masked CNPJ input: accepts digits and letters (A-Z case-insensitive), strips only mask chars . / -
 * Form state value is the unnormalized storage form (14 chars), same as previous NumberFormat digits-only.
 */
const CnpjFormatInput = React.forwardRef((props, ref) => {
  const { onChange, inputRef, value = '', ...other } = props;

  const body = normalizeCnpjForStorage(value);
  const display = formatCnpjMask(body);

  const setRef = instance => {
    if (typeof inputRef === 'function') {
      inputRef(instance);
    } else if (inputRef) {
      // eslint-disable-next-line no-param-reassign
      inputRef.current = instance;
    }
    if (typeof ref === 'function') {
      ref(instance);
    } else if (ref) {
      // eslint-disable-next-line no-param-reassign
      ref.current = instance;
    }
  };

  const handleChange = event => {
    const nextBody = normalizeCnpjForStorage(event.target.value);
    onChange({
      ...event,
      target: {
        ...event.target,
        value: nextBody
      }
    });
  };

  return (
    <input
      ref={setRef}
      {...other}
      value={display}
      onChange={handleChange}
    />
  );
});

CnpjFormatInput.displayName = 'CnpjFormatInput';

CnpjFormatInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  value: PropTypes.string
};

CnpjFormatInput.defaultProps = {
  inputRef: undefined,
  value: ''
};

export default CnpjFormatInput;
